import { render, staticRenderFns } from "./PaymentAddi.vue?vue&type=template&id=1dccc7be"
import script from "./PaymentAddi.vue?vue&type=script&lang=js"
export * from "./PaymentAddi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports